module.exports = __webpack_public_path__ + "img/lamp_fp.b79fc932.png";